// Catalogue des destinations proposées pour les 2 onglets personnalisables
// de la tab bar mobile (slots du milieu — « Aujourd'hui » et « Profil »
// restent fixes pour garantir l'accès à l'accueil et aux réglages).
// La préférence est stockée sur l'appareil (localStorage, clé lm-tab-slots)
// et propagée en direct via l'événement window « lm-tabs-changed ».
import React from 'react'

// Icônes vectorielles au trait — même style que MobileTabBar (stroke,
// fill none, hérité du CSS .lm-tabs button svg).
const ICONS = {
  grid: (
    <svg viewBox="0 0 24 24">
      <rect x="3" y="3" width="7.5" height="7.5" rx="2" />
      <rect x="13.5" y="3" width="7.5" height="7.5" rx="2" />
      <rect x="3" y="13.5" width="7.5" height="7.5" rx="2" />
      <rect x="13.5" y="13.5" width="7.5" height="7.5" rx="2" />
    </svg>
  ),
  calendar: (
    <svg viewBox="0 0 24 24">
      <rect x="3" y="5" width="18" height="16" rx="3" />
      <path d="M8 3v4M16 3v4M3 10h18" />
    </svg>
  ),
  cart: (
    <svg viewBox="0 0 24 24">
      <path d="M4 5h2l2.2 11h9.6L21 8H7" />
      <circle cx="10" cy="20" r="1.4" />
      <circle cx="17" cy="20" r="1.4" />
    </svg>
  ),
  wallet: (
    <svg viewBox="0 0 24 24">
      <rect x="3" y="6" width="18" height="14" rx="3" />
      <path d="M3 10h18M16 15h2" />
    </svg>
  ),
  chart: (
    <svg viewBox="0 0 24 24">
      <path d="M4 20V4" />
      <path d="M4 20h16" />
      <path d="M7 15l4-4 3 3 5-6" />
    </svg>
  ),
  check: (
    <svg viewBox="0 0 24 24">
      <rect x="3" y="3" width="18" height="18" rx="4" />
      <path d="M8 12.5l3 3 5.5-6" />
    </svg>
  ),
  users: (
    <svg viewBox="0 0 24 24">
      <circle cx="9" cy="9" r="3.4" />
      <path d="M3 20c0-3.2 2.7-5 6-5s6 1.8 6 5" />
      <path d="M16.5 5.4a3.4 3.4 0 010 6.6M18 15.3c1.9.6 3 2 3 4.7" />
    </svg>
  ),
  file: (
    <svg viewBox="0 0 24 24">
      <path d="M6 3h8l4 4v14H6z" />
      <path d="M14 3v4h4" />
    </svg>
  ),
  bell: (
    <svg viewBox="0 0 24 24">
      <path d="M6 16v-5a6 6 0 1112 0v5l1.5 2.5H4.5z" />
      <path d="M10 21a2 2 0 004 0" />
    </svg>
  ),
  flag: (
    <svg viewBox="0 0 24 24">
      <path d="M6 21V4" />
      <path d="M6 4h12l-2.5 4L18 12H6" />
    </svg>
  ),
  // GE-CAPPS — Apps custom (3 tuiles + un « + » : construites à la demande)
  apps: (
    <svg viewBox="0 0 24 24">
      <rect x="3" y="3" width="7.5" height="7.5" rx="2" />
      <rect x="13.5" y="3" width="7.5" height="7.5" rx="2" />
      <rect x="3" y="13.5" width="7.5" height="7.5" rx="2" />
      <path d="M17.25 14v6.5M14 17.25h6.5" />
    </svg>
  ),
}

// Chaque entrée : clé stable (stockée), route existante (casse exacte de
// App.js), libellé i18n + repli, icône et test d'activation.
export const TAB_CATALOG = [
  {
    key: 'domaines',
    path: '/domaines',
    label: ['tabs.domains', 'Domaines'],
    icon: ICONS.grid,
    isActive: (p) => p.startsWith('/domaines'),
  },
  {
    key: 'agenda',
    path: '/MonCalendrier',
    label: ['tabs.agenda', 'Agenda'],
    icon: ICONS.calendar,
    isActive: (p) => p.toLowerCase().startsWith('/moncalendrier'),
  },
  {
    key: 'courses',
    path: '/shopping',
    label: ['tabs.shopping', 'Courses'],
    icon: ICONS.cart,
    isActive: (p) => p.startsWith('/shopping'),
  },
  {
    key: 'budget',
    path: '/Monbudget',
    label: ['tabs.budget', 'Budget'],
    icon: ICONS.wallet,
    isActive: (p) => p.toLowerCase().startsWith('/monbudget'),
  },
  {
    key: 'patrimoine',
    path: '/MonPatrimoine',
    label: ['tabs.wealth', 'Patrimoine'],
    icon: ICONS.chart,
    isActive: (p) => p.toLowerCase().startsWith('/monpatrimoine'),
  },
  {
    key: 'taches',
    path: '/todos',
    label: ['tabs.tasks', 'Tâches'],
    icon: ICONS.check,
    isActive: (p) => p.startsWith('/todos'),
  },
  {
    key: 'contacts',
    path: '/MesContacts',
    label: ['tabs.contacts', 'Contacts'],
    icon: ICONS.users,
    isActive: (p) => p.toLowerCase().startsWith('/mescontacts'),
  },
  {
    key: 'documents',
    path: '/documents',
    label: ['tabs.documents', 'Documents'],
    icon: ICONS.file,
    isActive: (p) => p.startsWith('/documents'),
  },
  {
    key: 'inbox',
    path: '/inbox',
    label: ['tabs.inbox', 'Notifications'],
    icon: ICONS.bell,
    isActive: (p) => p.startsWith('/inbox'),
  },
  {
    key: 'roadmap',
    path: '/roadmap',
    label: ['tabs.roadmap', 'Roadmap'],
    icon: ICONS.flag,
    isActive: (p) => p.startsWith('/roadmap'),
  },
  {
    // GE-CAPPS — apps custom construites via le connecteur MCP Claude
    key: 'apps',
    path: '/apps',
    label: ['tabs.apps', 'Apps'],
    icon: ICONS.apps,
    isActive: (p) => p.startsWith('/apps'),
  },
]

export const DEFAULT_TAB_SLOTS = ['domaines', 'agenda']
const STORAGE_KEY = 'lm-tab-slots'
export const TABS_CHANGED_EVENT = 'lm-tabs-changed'

export const getCatalogEntry = (key) =>
  TAB_CATALOG.find((e) => e.key === key)

// Lit les 2 slots personnalisés ; toute valeur inconnue retombe sur le défaut
// (robuste aux clés retirées du catalogue dans une future version).
export const loadTabSlots = () => {
  try {
    const raw = JSON.parse(localStorage.getItem(STORAGE_KEY))
    if (Array.isArray(raw) && raw.length === 2) {
      return raw.map((k, i) =>
        getCatalogEntry(k) ? k : DEFAULT_TAB_SLOTS[i]
      )
    }
  } catch (_) {
    // JSON invalide → défauts
  }
  return [...DEFAULT_TAB_SLOTS]
}

export const saveTabSlots = (slots) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(slots))
  // Notifie la tab bar montée en parallèle (même onglet → l'événement
  // « storage » natif ne suffit pas).
  window.dispatchEvent(new Event(TABS_CHANGED_EVENT))
}
